import { render, staticRenderFns } from "./productForm.vue?vue&type=template&id=b0bfeef6"
import script from "./productForm.vue?vue&type=script&lang=js"
export * from "./productForm.vue?vue&type=script&lang=js"
import style0 from "./productForm.vue?vue&type=style&index=0&id=b0bfeef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports